import { render, staticRenderFns } from "./Demenagement.vue?vue&type=template&id=5275364f"
import script from "./Demenagement.vue?vue&type=script&lang=js"
export * from "./Demenagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports